<template>
  <div class="userSetingMain">
    <ul @mouseenter="userenter" @mouseleave="userleave">
      <li>
        <a :href="setJupmUrl + '/signin/update&code=' + token" target="_blank">
          <i slot="suffix" class="el-icon-setting" style="font-size: 16px"></i>
          账号设置
        </a>
      </li>
      <li>
        <a :href="setIndexUrl + '/tutorials&code=' + token" target="_blank">
          <i slot="suffix" class="icons new-user"></i>
          新手教程
          <i class="icon-new"></i>
        </a>
      </li>
      <li>
        <a
          :href="setJupmUrl + '/signin/invitation&code=' + token"
          target="_blank"
        >
          <i slot="suffix" class="icons user-qianxian"></i>
          权限升级
        </a>
      </li>
      <li>
        <a
          :href="
            setJupmUrl + '/signin/download?v=' + nowTime + '&code=' + token
          "
          target="_blank"
        >
          <i slot="suffix" class="icons user-download"></i>
          我的下载
        </a>
      </li>
      <li>
        <a :href="setJupmUrl + '/signin/myapi&code=' + token" target="_blank">
          <i slot="suffix" class="icons_18 user-api"></i>
          我的API
        </a>
      </li>
      <li>
        <a :href="setJupmUrl + '/signin/voucher&code=' + token" target="_blank">
          <i slot="suffix" class="icons_18_14 user-daijin"></i>
          代金券
          <i class="icon-new"></i>
        </a>
      </li>
      <li v-if="userLevel >= 50">
        <a
          :href="
            setJupmUrl + '/signin/couponcode?p=avatar_dropmenu&code=' + token
          "
          target="_blank"
        >
          <i slot="suffix" class="icons user-hezhuo"></i>
          合作转化
          <i class="icon-new"></i>
        </a>
      </li>
      <li>
        <a :href="logout">
          <i
            slot="suffix"
            class="el-icon-switch-button"
            style="font-size: 16px"
          ></i>
          退出
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import config from "../../assets/script/config";
import { mapState } from "vuex";
export default {
  name: "UserSeting",
  data() {
    return {
      settingUrl: config.settingUrl,
      logout: "//" + document.location.host + "/logout",
      setJupmUrl: config.payVipUrl,
      setIndexUrl: config.indexVipUrl,
      nowTime: this.newGetTime("minutes"),
      token: ""
    };
  },
  props: {
    userSeting: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.token = this.userToken;
  },
  computed: {
    ...mapState("user", ["userToken", "userLevel"])
  },
  watch: {
    userSeting: {
      handler(val) {
        let dom = document.getElementsByClassName("userSetingMain")[0];
        if (val) {
          dom.style.display = "block";
        } else {
          dom.style.display = "none";
        }
      }
    },
    userToken: {
      handler(val) {
        if (val) {
          this.token = this.userToken;
        }
      }
    }
  },
  methods: {
    userenter() {
      this.$emit("userenter", true);
    },
    userleave() {
      this.$emit("userenter", false);
    }
  }
};
</script>

<style lang="less" scoped>
.userSetingMain {
  display: none;
}
ul {
  position: absolute;
  top: 60px;
  right: 5px;
  width: 160px;
  padding: 10px 20px;
  background-color: #fff;
  list-style-type: none;
  border: 1px solid #e6e6e6;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  z-index: 2000;
  li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #e6e6e6;
    .icons {
      display: inline-block;
      height: 16px;
      width: 16px;
      vertical-align: middle;
      margin-top: -2px;
    }
    .icons_18 {
      .icons();
      height: 18px;
      width: 18px;
    }
    .icons_18_14 {
      .icons();
      height: 14px;
      width: 18px;
    }
    .new-user {
      background: url("../../assets/image/icon/fingerpost-icon.png") no-repeat
        50%;
    }
    .user-qianxian {
      background: url("../../assets/image/icon/quanxian2.png") no-repeat 50%;
    }
    .user-download {
      background: url("../../assets/image/icon/download1.png") no-repeat 50%;
    }
    .user-api {
      background: url("../../assets/image/icon/api-icon.png") no-repeat 50%;
    }
    .user-daijin {
      background: url("../../assets/image/icon/voucher-icon.png") no-repeat 50%;
    }
    .user-hezhuo {
      background: url("../../assets/image/icon/shouyi.png") no-repeat 50%;
    }
    a {
      display: block;
      width: 100%;
      height: 100%;
      line-height: 40px;
      color: #666;
      font-size: 14px;
    }
    &:last-child {
      border-bottom: 0;
    }
    &:before {
      content: "";
      display: block;
      position: absolute;
      border-left: 0;
      z-index: 2;
      right: 40px;
      top: -12px;
      border: 6px solid transparent;
      border-bottom: 6px solid #fff;
    }
    .icon-account-new {
      display: inline-block;
      font-size: 0;
      background-image: url("../../assets/image/sprite.icon.png?v=c7552ca40e");
    }
    .icon-new {
      .icon-account-new();
      background-position: 0 -265px;
      width: 24px;
      height: 14px;
    }
  }
}
</style>
